(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-snomed', {
            parent: 'entity',
            url: '/rcopia-snomed',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaSnomeds'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomeds.html',
                    controller: 'RcopiaSnomedController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-snomed-detail', {
            parent: 'entity',
            url: '/rcopia-snomed/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaSnomed'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-detail.html',
                    controller: 'RcopiaSnomedDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaSnomed', function($stateParams, RcopiaSnomed) {
                    return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-snomed',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-snomed-detail.edit', {
            parent: 'rcopia-snomed-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-snomed.new', {
            parent: 'rcopia-snomed',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                ctConceptID: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('rcopia-snomed');
                });
            }]
        })
        .state('rcopia-snomed.edit', {
            parent: 'rcopia-snomed',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-snomed.delete', {
            parent: 'rcopia-snomed',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-delete-dialog.html',
                    controller: 'RcopiaSnomedDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
